<script lang="ts" setup>
  import HostErrorMessage from './HostErrorMessage.vue';
  import WarningIcon from './WarningIcon.vue';
</script>

<template>
  <HostErrorMessage title="Audio device not supported">
    <p>Songstar tried playing its lobby music on your device, but the device is not supported.</p>
    <div class="known-cause">
      <WarningIcon class="warning-icon" />
      <p>A known cause of this error is playing music from Spotify on Sonos over Wi-Fi.</p>
    </div>
    <ol>
      <li>Play your music in a different manner than you are currently playing (E.G. with bluetooth to a speaker)</li>
      <li>Sign in again</li>
    </ol>
  </HostErrorMessage>
</template>

<style scoped>
  .known-cause {
    align-items: center;
    color: var(--color-warning);
    display: flex;
    gap: 0.5rem;
  }

  .known-cause p {
    font-size: var(--font-size-sm);
    text-align: left;
  }

  .warning-icon {
    flex-shrink: 0;
    height: 1.5rem;
    width: 1.5rem;
  }
</style>
